import type { RouteResources } from '@atlassian/react-resource-router';
/* eslint-disable import/order */
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { globalSettingsProjectsCategoriesViewRoute } from '@jira/router-routes__legacy-global-settings-projects-categories-view-routes/src/globalSettingsProjectsCategoriesViewRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsProjectsCategoriesViewRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsProjectsCategoriesViewRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
		},

		resources: [navigationSidebarGlobalResource],
		entryPoint: () => pageEntryPoint,
	}));
